import React from "react";
import img1 from "../../../Assets/UserSide/Discoveryourstayimgs.png";
import img2 from "../../../Assets/UserSide/ScheduleVisit.png";
import img3 from "../../../Assets/UserSide/ChooseBook.png";
import img4 from "../../../Assets/UserSide/MoveIn.png";
import ellipse from "../../../Assets/howitworks/rightEllipse.svg";
import "aos/dist/aos.css";

const HowItWorks = () => {
  return (
    <div className="bg-gradient-to-b tracking-wide from-white to-blue-100 text-gray-800 px-4 pb-5 md:px-16 mt-10">
      <div>
        {/* Section Title */}
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-4">
          How Our Booking Process Works
        </h1>
        <p className="text-center mb-8 text-[#6B737A] max-w-[90%] md:max-w-[70%] mx-auto">
          Finding and securing your ideal hostel or PG accommodation in
          Bhubaneswar is straightforward with our four-step process:
        </p>

        {/* STEP 1: Discover Your Stay */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 ">
          <div data-aos="fade-right">
            <img
              src={img1}
              alt="Discover Your Stay"
              className="w-[100%] mx-auto"
            />
          </div>
          <div className="flex items-center" data-aos="fade-left">
            <div className="relative z-50">
              <h2 className="text-lg md:text-xl font-bold text-[#202224] mb-2 flex gap-1 items-center">
                <span className="text-[#FF0000]">STEP 1 :-</span>{" "}
                <h1 className="sm:text-2xl text-xl">Discover your stay</h1>
              </h2>
              <h3 className="text-md md:text-lg text-[#202224] font-semibold mb-2">
                Explore Listings
              </h3>
              <p className="mb-4 text-[#6B737A] text-[1.1rem]">
                Browse our extensive selection of properties across Bhubaneswar.
                Each listing offers detailed information, including amenities,
                photos, and pricing, to help you make an informed decision.
              </p>
              <h3 className="text-md md:text-lg font-semibold mb-2">
                Filter Your Preferences
              </h3>
              <p className="text-[#6B737A] text-[1.1rem]">
                Utilize search filters to narrow down options based on location,
                price, amenities, and room type. Whether you're seeking single
                occupancy, double occupancy, or shared living spaces, we have
                options to suit your needs.
              </p>
              <img
                src={ellipse}
                alt=""
                className="absolute -right-56 -top-64 object-cover  "
              />
            </div>
          </div>
        </div>

        {/* STEP 2: Schedule a Visit */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 mt-10">
          <div
            className="flex items-center lg:order-1 order-2"
            data-aos="fade-right"
          >
            <div className="relative z-50">
              <h2 className="text-lg md:text-xl font-bold text-[#202224] mb-2 flex gap-1 items-center">
                <span className="text-[#FF0000]">STEP 2 :-</span>{" "}
                <h1 className="sm:text-2xl text-xl">Schedule a Visit</h1>
              </h2>
              <h3 className="text-md md:text-lg text-[#202224] font-semibold mb-2">
                Book a Tour
              </h3>
              <img
                src={ellipse}
                alt=""
                className="absolute -left-56 -top-64 object-cover "
              />
              <p className="mb-4 text-[#6B737A] text-[1.1rem]">
                Arrange a visit to your preferred property. Our team will guide
                you through the space and address any questions you may have.
              </p>
              <h3 className="text-md md:text-lg font-semibold mb-2">
                Virtual Tours Available
              </h3>
              <p className="text-[#6B737A] text-[1.1rem]">
                If an in-person visit isn't feasible, we offer virtual tours for
                your convenience.
              </p>
            </div>
          </div>
          <div data-aos="fade-left" className="lg:order-2 order-1">
            <img
              src={img2}
              alt="Schedule a Visit"
              className="w-[100%] mx-auto"
            />
          </div>
        </div>

        {/* STEP 3: Choose & Book */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 mt-10">
          <div data-aos="fade-right">
            <img
              src={img3}
              alt="Choose and Book"
              className="w-[100%] mx-auto"
            />
          </div>
          <div className="flex items-center" data-aos="fade-left">
            <div className="relative z-50">
              <h2 className="text-lg md:text-xl font-bold text-[#202224] mb-2 flex gap-1 items-center">
                <span className="text-[#FF0000]">STEP 3 :-</span>{" "}
                <h1 className="sm:text-2xl text-xl">Choose & Book</h1>
              </h2>
              <h3 className="text-md md:text-lg text-[#202224] font-semibold mb-2">
                Finalize Your Choice
              </h3>
              <p className="mb-4 text-[#6B737A] text-[1.1rem]">
                After selecting a property, complete the booking process online
                or with assistance from our team.
              </p>
              <h3 className="text-md md:text-lg font-semibold mb-2">
                Flexible Payment Options
              </h3>
              <p className="text-[#6B737A] text-[1.1rem]">
                We provide multiple payment methods for your convenience. Select
                the plan that best fits your requirements.
              </p>
              <img
                src={ellipse}
                alt=""
                className="absolute -right-56 -top-40 object-cover "
              />
            </div>
          </div>
        </div>

        {/* STEP 4: Move In */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 mt-10">
          <div
            className="flex items-center lg:order-1 order-2"
            data-aos="fade-right"
          >
            <div className="relative z-50">
              <h2 className="text-lg md:text-xl font-bold text-[#202224] mb-2 flex gap-1 items-center">
                <span className="text-[#FF0000]">STEP 4 :-</span>{" "}
                <h1 className="sm:text-2xl text-xl">Move In</h1>
              </h2>
              <h3 className="text-md md:text-lg text-[#202224] font-semibold mb-2">
                Hassle-Free Onboarding
              </h3>
              <img
                src={ellipse}
                alt=""
                className="absolute -left-56 -top-40 object-cover"
              />
              <p className="mb-4 text-[#6B737A] text-[1.1rem]">
                Our team will assist you throughout the move-in process, from
                key handover to settling into your new space, ensuring a smooth
                transition.
              </p>

              <p className="mb-4 text-[#6B737A] text-[1.1rem]">
                By following these steps, securing your ideal accommodation in
                Bhubaneswar is both simple and efficient.
              </p>
              {/* <h3 className="text-md md:text-lg font-semibold mb-2 text-[#202224]">
                Welcome Kit
              </h3>
              <p className="text-[#6B737A] text-[1.1rem]">
                Receive a welcome kit with essentials to get you started. It
                includes items like toiletries, kitchen basics, and more to make
                your first few days comfortable.
              </p> */}
            </div>
          </div>
          <div data-aos="fade-left" className="lg:order-2 order-1">
            <img src={img4} alt="Move In" className="w-[100%] mx-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
